export default "__VITE_ASSET__BwYw$7Lb__"